import clsx from "clsx";
import React from "react";

import styles from "./Logo.module.scss";

interface LogoContainerProps {
  children: React.ReactNode;
  centered?: boolean;
  className?: string;
  dataTestid?: string;
}

function LogoContainer({
  children,
  centered = false,
  className,
  dataTestid,
}: LogoContainerProps) {
  return (
    <div
      id="logo-container"
      className={clsx(
        styles.logoWrapper,
        className,
        centered && styles.centered
      )}
      data-testid={dataTestid || "logo-container"}
    >
      {children}
    </div>
  );
}

export default LogoContainer;
